import { Button, Col, DatePicker, Form, Row } from "antd";
import BieuDo from "components/bieuDo";
import FillterTable from "components/FillterTable";
import { PopUpAddGraphical } from "components/popupAddGraphical";
import RenderForm from "components/renderForm";
import TablePagination from "components/TablePagination";
import dayjs from "dayjs";
import { exportTableToExcelNew } from "helpers";
import { ConverData, ConverDataName } from "helpers/dataToAntdSelect";
import { useEffect, useMemo, useState } from "react";
import { useQueries } from "react-query";
import { getAppVersions, getAudiences, getCampaigns, getMiniapps, getOnlineStoreOrderStatus, getOnlineStoreUrl, getPartners, getPaymentChannels, getPlatforms, getServicePackages, getServices, getStaffs, getTransactionTypes } from "services/apiRequest";
import { getDataOnlineStoreReport, getOnlineStoreReportGraphical } from "services/onlineStoreRequest";
import { getDataStatisticsRevenueReport, getGraphicalStatisticsRevenueReport } from "services/revenueReportRequest";

const rangePresets = [
    {
        label: '7 ngày trước',
        value: [dayjs().add(-7, 'd'), dayjs()],
    },
    {
        label: '14 ngày trước',
        value: [dayjs().add(-14, 'd'), dayjs()],
    },
    {
        label: '30 ngày trước',
        value: [dayjs().add(-30, 'd'), dayjs()],
    },
    {
        label: '90 ngày trước',
        value: [dayjs().add(-90, 'd'), dayjs()],
    },
];

const metricId = 14;
const dimensionId = 14;

export default function OnlineStore() {

    const [form] = Form.useForm();

    const [tableFields, setTableFields] = useState({ metricIds: [1, 2], dimensionIds: [1] });

    const [{ data: dataMiniapps }, { data: dataOnlineStoreOrderStatus }, { data: dataOnlineStoreUrl },
        { data: dataPartners }] = useQueries([
            {
                queryKey: ["dataMiniapps"],
                queryFn: () => getMiniapps(),
            },
            {
                queryKey: ["dataOnlineStoreOrderStatus"],
                queryFn: () => getOnlineStoreOrderStatus(),
            },
            {
                queryKey: ["dataOnlineStoreUrl"],
                queryFn: () => getOnlineStoreUrl(),
            },
            {
                queryKey: ["dataPartners"],
                queryFn: () => getPartners(),
            },
        ]);
    const [dataExport, setDataExport] = useState(null);

    const [graphical, setGraphical] = useState(null);

    const watchForm = Form.useWatch([], form);

    // const listGoiDichVu = useMemo(() => {
    //     if (!watchForm) {
    //         return dataServicePackages?.data;
    //     }

    //     const { serviceIds, servicePackageIds } = watchForm;

    //     if (serviceIds?.length == 0) {
    //         return dataServicePackages?.data;
    //     }

    //     const dataCompare = [...dataServicePackages?.data];

    //     const data = dataCompare.filter(item => serviceIds.includes(+item.service_id));

    //     const idServicePackageIds = data.map(item => +item.id);

    //     // Kiểm tra phần tử trong idServicePackageIds không thuộc trong data và không phải 0
    //     const invalidIds = servicePackageIds.filter(item => !idServicePackageIds.includes(item));

    //     const hasInvalidIds = invalidIds.length > 0; // Kiểm tra nếu có id không hợp lệ

    //     if (hasInvalidIds) {
    //         form.setFieldValue("servicePackageIds", []);
    //     }

    //     return data;

    // }, [watchForm?.serviceIds]);

    const setUpFormModal = [
        {
            name: 'range-time',
            type: 'range-picker',
            lg: 6,
            propsInput: {
                format: "DD/MM/YYYY",
                presets: rangePresets
                // showSearch: true,
                // allowClear: true
            },
            label: 'Thời gian',
        },
        {
            name: 'partnerIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Đối tác',
            options: ConverData(dataPartners?.data || []),
        },
        {
            name: 'miniappIds',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Ứng dụng',
            options: ConverData(dataMiniapps?.data || []),
        },
        {
            name: 'urls',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'URL',
            options: ConverData(dataOnlineStoreUrl?.data || []),
        },
        {
            name: 'orderStatuses',
            type: 'select',
            lg: 6,
            propsInput: {
                showSearch: true,
                allowClear: true,
                mode: 'multiple',
            },
            label: 'Trạng thái đơn hàng',
            options: ConverData(dataOnlineStoreOrderStatus?.data || []),
        },
        {
            type: "html",
            lg: 3,
            content: (
                <Row className={"flex justify-start items-end content-end h-full"}>
                    <Button type="primary"
                        onClick={() => {
                            form.submit();
                        }}
                    >Áp dụng</Button>
                </Row>
            ),
        },
    ];

    const [whereCondition, setWhereCondition] = useState({
        startTime: dayjs().subtract(30, 'days').format("DD/MM/YYYY"),
        endTime: dayjs().format("DD/MM/YYYY"),
        partnerIds: [],
        miniappIds: [],
        urls: [],
        orderStatuses: [],
    });

    useEffect(() => {

        let initialValues = Object.assign({}, whereCondition);

        const startTime = dayjs(initialValues.startTime, 'DD/MM/YYYY').isValid() ? dayjs(initialValues.startTime, 'DD/MM/YYYY') : null;
        const endTime = dayjs(initialValues.endTime, 'DD/MM/YYYY').isValid() ? dayjs(initialValues.endTime, 'DD/MM/YYYY') : null;

        initialValues['range-time'] = [startTime, endTime];

        form.setFieldsValue(initialValues);
    }, []);

    return (
        <div className="px-7">
            <div className="flex flex-col gap-5 p-7 card">
                <div className="flex items-center justify-items-center justify-between">
                    <h1>
                        <b>THỐNG KÊ MINI APP</b>
                    </h1>

                    <div className="flex justify-content-end gap-3">
                        <Button
                            type="primary"
                            onClick={() => {
                                exportTableToExcelNew(dataExport, "THONG_KE_ONLINE_STORE");
                            }}
                        >
                            Export
                        </Button>
                        <PopUpAddGraphical
                            metricId={metricId}
                            dimensionId={dimensionId}
                            addDataFields={values => {
                                const newValues = { ...values };
                                setGraphical(newValues);
                            }}
                        />
                    </div>
                </div>

                <RenderForm
                    onFinish={(values) => {
                        let dataQueries = {};

                        Object.keys(values).map(key => {
                            const item = values[key];
                            if (key == "range-time") {

                                const startTime = dayjs(item[0]).format('DD/MM/YYYY');
                                const endTime = dayjs(item[1]).format('DD/MM/YYYY');

                                dataQueries.startTime = startTime;
                                dataQueries.endTime = endTime;
                            } else {
                                if (item) {
                                    dataQueries[key] = item;
                                } else {
                                    dataQueries[key] = [];
                                }
                            }
                        })

                        setWhereCondition(dataQueries);
                    }}
                    form={form}
                    fields={setUpFormModal}
                    footer={<></>}
                />

                <BieuDo
                    metricId={metricId}
                    dimensionId={dimensionId}
                    whereCondition={whereCondition}
                    apiCallBack={getOnlineStoreReportGraphical}
                    dataFields={[{ metricIds: [1], dimensionIds: [null] }]}
                    addGraphical={graphical}
                />

                <div className="flex w-full">
                    <Row className="w-full" justify="space-between" gutter={[10, 10]}>
                        <Col span={20}>
                            <TablePagination
                                apiCallBack={getDataOnlineStoreReport}
                                whereCondition={whereCondition}
                                dataFields={tableFields}
                                dataTableChange={values => {
                                    setDataExport(values);
                                }}
                            />
                        </Col>
                        <Col span={4}>
                            <FillterTable
                                metricId={metricId}
                                dimensionId={dimensionId}
                                dataFields={tableFields}
                                onFieldsChange={values => {
                                    setTableFields(values);
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}